import * as React from 'react'
import * as Snippets from 'snippets'
import { ShopifyNext } from '@dotdev/next-components'

export class FourtyAnCard extends React.PureComponent<FourtyAnCard.Props> {
  public render(): JSX.Element {
    const { article, isTwoColumn, imageWidth, ratio } = this.props
    
    return (
      <a href={article.url} className={'block md:px-1-2 max-w-full'}>
        <div className={'px-1-2 w-auto max-w-full'}>
          {article.image ? 
            <div className="relative overflow-hidden max-w-full" style={{
              width: imageWidth + 'px',
            }}>
              <div className="relative" style={{
                paddingBottom: ratio + '%'
              }}>
                <img
                  alt={article.title}
                  src={article.image}
                  className="absolute top-0 left-0 object-cover w-full h-full"
                />
              </div>
            </div>
            : null}
          <div 
            style={{
              maxWidth: '85%'
            }} 
            className={'w-auto pr-1-6 pt-2 pb-3-6 md:pb-3'}
          >
            <Snippets.Heading size={'h1'} tag={'h5'} className={'mb-0-8 font-mono'}>
              {article.title}
            </Snippets.Heading>
            {article.excerpt ? <Snippets.RichText truncate={window.innerWidth < 768 ? 400 : isTwoColumn ? 160 : 400} className={'mb-1-2 leading-1.4'}>
              {article.excerpt}
            </Snippets.RichText> : null}
            {article.url ? <Snippets.Button
              title={`Read Article ${article.title}`}
              colour={'blank'}
              className={'border-b border-black pb-0-5'}
            >
              <Snippets.Heading size={'h5'} tag={'p'} className={'tracking-wider'}>Read More</Snippets.Heading>
            </Snippets.Button> : null}
          </div>
        </div>
      </a>
    )
  }
}

export namespace FourtyAnCard {
  export interface Props {
    isTwoColumn?: boolean;
    imageWidth?: number;
    ratio?: number;
    article: {
      title?: string;
      url?: string;
      tags?: string[];
      image?: string;
      published_at?: string;
      excerpt?: string;
    };
  }
}
